import { render } from "./Survivor.vue?vue&type=template&id=87f53b0c&scoped=true"
import script from "./Survivor.vue?vue&type=script&lang=js"
export * from "./Survivor.vue?vue&type=script&lang=js"

import "./Survivor.vue?vue&type=style&index=0&id=87f53b0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f53b0c"]])

export default __exports__